import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { useData } from "../../hooks/useData";

// Animated testimonial slider with glass cards.
export default function Testimonials() {
  const { data } = useData("testimonials");
  const [i, setI] = useState(0);

  useEffect(() => {
    if (!data) return;
    const t = setInterval(() => setI((p) => (p + 1) % data.items.length), 6000);
    return () => clearInterval(t);
  }, [data]);

  if (!data) return null;
  const t = data.items[i];
  const go = (d) => setI((p) => (p + d + data.items.length) % data.items.length);

  return (
    <div className="relative mx-auto max-w-3xl" data-testid="testimonials-slider">
      <AnimatePresence mode="wait">
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -24 }}
          transition={{ duration: 0.5 }}
          className="rounded-3xl glass-strong p-8 text-center sm:p-12"
        >
          <Quote className="mx-auto text-brand" size={36} />
          <div className="mt-4 flex justify-center gap-1">
            {Array.from({ length: t.rating }).map((_, k) => (
              <Star key={k} size={18} className="fill-amber-400 text-amber-400" />
            ))}
          </div>
          <p className="mt-5 text-lg text-slate-700 sm:text-xl">&ldquo;{t.quote}&rdquo;</p>
          <div className="mt-7 flex items-center justify-center gap-3">
            <img src={t.avatar} alt={t.name} loading="lazy" className="h-12 w-12 rounded-full object-cover ring-2 ring-[color:var(--brand)]/40" />
            <div className="text-left">
              <p className="font-semibold text-slate-900">{t.name}</p>
              <p className="text-xs text-slate-500">{t.role}</p>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

      <div className="mt-6 flex items-center justify-center gap-4">
        <button onClick={() => go(-1)} className="flex h-10 w-10 items-center justify-center rounded-full glass text-slate-600 hover:text-slate-900" data-testid="testimonial-prev" aria-label="Previous">
          <ChevronLeft size={18} />
        </button>
        <div className="flex gap-2">
          {data.items.map((_, k) => (
            <button key={k} onClick={() => setI(k)} className={`h-1.5 rounded-full transition-all ${k === i ? "w-6 bg-brand" : "w-1.5 bg-slate-300"}`} aria-label={`Testimonial ${k + 1}`} data-testid={`testimonial-dot-${k}`} />
          ))}
        </div>
        <button onClick={() => go(1)} className="flex h-10 w-10 items-center justify-center rounded-full glass text-slate-600 hover:text-slate-900" data-testid="testimonial-next" aria-label="Next">
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}
